import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { deleteMessageFromChat } from '../../../actions/sendMessage';
import { retrySendMessageById } from '../../../actions/sendMessage/retrySendMessageById';
import { currentChatOpponentIdSelector, currentOpenChatIDSelector, currentOpenChatSelector } from '../../../selectors';
import { TOpenedChat } from '../../../types/openedChats';
import { useApplicationContext } from '../../../utils/applicationContext';
import { trackFileErrorMenuClick } from '../tracking';

type TMenuItem = {
  title: React.ReactNode;
  handler(): void;
};

export const useMessageErrorMenu = (messageId: string, isOfferMessage: boolean): TMenuItem[] => {
  const dispatch = useDispatch();
  const chatId = useSelector(currentOpenChatIDSelector) || '';
  const opponentId = useSelector(currentChatOpponentIdSelector);
  const {
    custom: { messagesMap, socket },
  } = useApplicationContext();

  const currentChat = useSelector(currentOpenChatSelector);
  const { pendingFiles } = currentChat || ({} as TOpenedChat);

  const fileType = React.useMemo(() => {
    const blobFiles = pendingFiles?.[messageId]?.blobFiles || [];

    return blobFiles[0]?.type;
  }, [messageId, pendingFiles]);

  return React.useMemo(
    () => [
      {
        title: <UIText2 color="text-primary-default">Отправить снова</UIText2>,
        handler: () => {
          dispatch(retrySendMessageById(chatId as string, messageId));
          trackFileErrorMenuClick({
            action: 'Reload_sopr',
            fileType,
            chatId,
            label: isOfferMessage ? 'Offer' : '',
            opponentId,
          });
        },
      },
      {
        title: <UIText2 color="text-primary-default">Удалить сообщение</UIText2>,
        handler: () => {
          dispatch(deleteMessageFromChat({ chatId, messageId, messagesMap }));
          socket?.clientEvents.delete(messageId);
          trackFileErrorMenuClick({
            action: 'Delete_sopr',
            fileType,
            chatId,
            label: isOfferMessage ? 'Offer' : '',
            opponentId,
          });
        },
      },
    ],
    [dispatch, chatId, messageId, fileType, isOfferMessage, opponentId, messagesMap, socket],
  );
};
